/* eslint-disable import/prefer-default-export */
import config from '@medflex/utils/config';

/**
 * Number of seconds between a first and consecutive messages from same sender
 * within messages should be displayed in a special grouped style.
 */
export const SECONDS_GROUP_CONSECUTIVE_MESSAGES = Number(config.SECONDS_GROUP_CONSECUTIVE_MESSAGES);

export const CALL_INFO_CENTER_URLS = {
  videoCallTerms: 'https://medflex.de/hilfe/behandler-datenschutz-und-sicherheit/datenschutz',
  physician: {
    howTo: 'https://medflex.de/hilfe/patienten-video/videosprechstunde-ueber-medflex/',
    howToSchedule: 'https://medflex.de/hilfe/behandler-video/videotermine-durchfuehren/',
  },
  patient: {
    howTo: 'https://medflex.de/hilfe/patienten-video/videosprechstunde-ueber-medflex/',
  },
};

// https://support.tokbox.com/hc/en-us/articles/360029732311-What-is-the-minimum-bandwidth-requirement-to-use-OpenTok-
export const QUALITY_CRITERIA = [
  {
    resolutionPer30FPS: '1280x720',
    minKbps: 100,
    maxPacketLossPercent: 3,
    quality: 'acceptable',
  },
  {
    resolutionPer30FPS: '640x480',
    minKbps: 100,
    maxPacketLossPercent: 3,
    quality: 'acceptable',
  },
  {
    resolutionPer30FPS: '352x288',
    minKbps: 50,
    maxPacketLossPercent: 3,
    quality: 'acceptable',
  },
  {
    resolutionPer30FPS: '320x240',
    minKbps: 50,
    maxPacketLossPercent: 3,
    quality: 'acceptable',
  },
];

export const PRECALL_TEST_URL = `${config.BASE_URL}/sessions/vorab-test`;

export const CALL_RINGING_TONE_TIMEOUT = 30000;
